/**
 * @generated SignedSource<<df65134562b938e2e598c98b958fb1a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type ProfileScreenQuery$variables = {
  currentEmployeeId?: string | null;
};
export type ProfileScreenQuery$data = {
  readonly me: {
    readonly stores: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
  readonly store: {
    readonly currentEmployee: {
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"ProfileScreenEmployee_employee">;
    } | null;
    readonly id: string;
    readonly myRole: Roles;
    readonly todoCategories: ReadonlyArray<{
      readonly assignedCount: {
        readonly totalCount: number;
      };
      readonly assignedTodos: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly ordinal: string;
            readonly " $fragmentSpreads": FragmentRefs<"TodoListItem_todo">;
          };
        }>;
      };
      readonly createdCount: {
        readonly totalCount: number;
      };
      readonly createdTodos: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly ordinal: string;
            readonly " $fragmentSpreads": FragmentRefs<"TodoListItem_todo">;
          };
        }>;
      };
      readonly icon: TodoCategoryIcon | null;
      readonly id: string;
      readonly title: string;
    }>;
  };
  readonly storeViewer: {
    readonly events: ReadonlyArray<{
      readonly __typename: string;
      readonly assigned?: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly assignedRoles?: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly routine?: {
        readonly currentSchedule: {
          readonly __typename: string;
        } | null;
        readonly description: string | null;
        readonly descriptionImages: ReadonlyArray<{
          readonly __typename: "Image";
        }>;
        readonly ownerTeam: {
          readonly color: string | null;
        } | null;
      };
      readonly startAt: string;
      readonly taskExecution?: {
        readonly routineOccasion: {
          readonly assigned: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly assignedRoles: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly routine: {
            readonly currentSchedule: {
              readonly __typename: string;
            } | null;
            readonly description: string | null;
            readonly descriptionImages: ReadonlyArray<{
              readonly __typename: "Image";
            }>;
            readonly ownerTeam: {
              readonly color: string | null;
            } | null;
          };
        };
      };
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItem_TeamScheduleEventOccasion">;
    } | null>;
  } | null;
};
export type ProfileScreenQuery = {
  response: ProfileScreenQuery$data;
  variables: ProfileScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentEmployeeId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "stores",
  "plural": true,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "currentEmployeeId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v8 = [
  (v6/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "currentSchedule",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Routine",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "ownerTeam",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "descriptionImages",
        "plural": true,
        "selections": (v8/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AssignedEmployee",
    "kind": "LinkedField",
    "name": "assigned",
    "plural": true,
    "selections": (v2/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AssignedRole",
    "kind": "LinkedField",
    "name": "assignedRoles",
    "plural": true,
    "selections": (v2/*: any*/),
    "storageKey": null
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "currentEmployeeId"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "myRole",
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "includeDefault",
    "value": true
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v18 = {
  "kind": "Variable",
  "name": "assignedToEmployeeId",
  "variableName": "currentEmployeeId"
},
v19 = {
  "kind": "Literal",
  "name": "assignedToMe",
  "value": true
},
v20 = {
  "kind": "Literal",
  "name": "includeNewlyCompleted",
  "value": false
},
v21 = {
  "kind": "Literal",
  "name": "includeSubTodos",
  "value": true
},
v22 = {
  "kind": "Literal",
  "name": "status",
  "value": "PENDING"
},
v23 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v24 = {
  "alias": "assignedCount",
  "args": [
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/)
  ],
  "concreteType": "TodoConnection",
  "kind": "LinkedField",
  "name": "todos",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "kind": "Variable",
  "name": "createdByEmployeeId",
  "variableName": "currentEmployeeId"
},
v26 = {
  "kind": "Literal",
  "name": "createdByMe",
  "value": true
},
v27 = {
  "alias": "createdCount",
  "args": [
    (v25/*: any*/),
    (v26/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/)
  ],
  "concreteType": "TodoConnection",
  "kind": "LinkedField",
  "name": "todos",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v28 = {
  "kind": "Literal",
  "name": "includeNewlyCompleted",
  "value": true
},
v29 = [
  (v18/*: any*/),
  (v19/*: any*/),
  (v28/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v31 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TodoEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v30/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TodoListItem_todo"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v32 = [
  (v25/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v33 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "TIME_ONLY"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
  }
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "startAtDate",
  "plural": false,
  "selections": (v33/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "deadlineAtDate",
  "plural": false,
  "selections": (v33/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expireAt",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v46 = [
  (v1/*: any*/),
  (v41/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/)
    ],
    "storageKey": null
  }
],
v47 = {
  "kind": "InlineFragment",
  "selections": (v46/*: any*/),
  "type": "Image",
  "abstractKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    (v47/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedAt",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v39/*: any*/),
        (v13/*: any*/),
        (v40/*: any*/),
        (v48/*: any*/)
      ],
      "storageKey": null
    },
    (v1/*: any*/),
    (v49/*: any*/)
  ],
  "storageKey": null
},
v51 = [
  (v1/*: any*/),
  (v13/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v48/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "EmployeeRole",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v13/*: any*/),
    (v39/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employeeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employees",
      "plural": true,
      "selections": (v51/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    (v52/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedTaskExecutionCount",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgIconUri",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "descriptionImages",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        (v44/*: any*/),
        (v45/*: any*/),
        (v1/*: any*/),
        (v42/*: any*/),
        (v43/*: any*/)
      ],
      "storageKey": null
    },
    (v41/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "descriptionFiles",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v42/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v58/*: any*/)
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "ownerTeam",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isScheduledOccasion"
},
v65 = [
  (v6/*: any*/),
  (v1/*: any*/)
],
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v46/*: any*/),
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "style",
      "value": "DEFAULT"
    }
  ],
  "kind": "ScalarField",
  "name": "storeFormattedDate",
  "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
},
v70 = [
  (v69/*: any*/)
],
v71 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v48/*: any*/),
    (v40/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v73 = [
  (v13/*: any*/),
  (v1/*: any*/)
],
v74 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screen",
      "plural": false,
      "selections": (v73/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ScreenActor",
  "abstractKey": null
},
v75 = [
  (v72/*: any*/)
],
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": (v73/*: any*/),
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
},
v78 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TodoEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v30/*: any*/),
          (v66/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v67/*: any*/)
                ],
                "type": "TodoResponseImage",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canWrite",
            "storageKey": null
          },
          (v58/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formattedBody",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canChangeStatus",
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isIssue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoContact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              (v68/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "feedbackStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignedEmployee",
            "kind": "LinkedField",
            "name": "assigned",
            "plural": true,
            "selections": [
              (v49/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employee",
                "plural": false,
                "selections": (v51/*: any*/),
                "storageKey": null
              },
              (v1/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignedRole",
            "kind": "LinkedField",
            "name": "assignedRoles",
            "plural": true,
            "selections": [
              (v52/*: any*/),
              (v1/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "expireAtDate",
            "plural": false,
            "selections": [
              (v69/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isoString",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategoryTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v7/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "subTodos",
            "plural": true,
            "selections": [
              (v66/*: any*/),
              (v1/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "commentCount",
            "storageKey": null
          },
          (v37/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isResponseCompleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "resolvedAtDate",
            "plural": false,
            "selections": (v70/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "lastChangedStatusByActor",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v71/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreUser",
                    "kind": "LinkedField",
                    "name": "storeUser",
                    "plural": false,
                    "selections": [
                      (v72/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v73/*: any*/),
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UserActor",
                "abstractKey": null
              },
              (v74/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v75/*: any*/),
                "type": "GroupActor",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v75/*: any*/),
                "type": "ConnectActor",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v67/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "createdAtDate",
            "plural": false,
            "selections": (v70/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeToResolvedFormatted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoSubject",
            "kind": "LinkedField",
            "name": "subject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoSubjectBreadcrumb",
                "kind": "LinkedField",
                "name": "allBreadcrumbs",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiredToDescribeTodo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iconUri",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "createdByActor",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v71/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreUser",
                    "kind": "LinkedField",
                    "name": "storeUser",
                    "plural": false,
                    "selections": [
                      (v76/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v68/*: any*/),
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrgDescription",
                            "kind": "LinkedField",
                            "name": "orgDescription",
                            "plural": false,
                            "selections": [
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UserActor",
                "abstractKey": null
              },
              (v74/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employee",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v1/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v77/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v65/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "GroupActor",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v77/*: any*/),
                  (v76/*: any*/)
                ],
                "type": "ConnectActor",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "StoreViewer",
        "kind": "LinkedField",
        "name": "storeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "events",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamScheduleListItem_TeamScheduleEventOccasion"
              },
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "RoutineOccasion",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskExecutionCheck",
                    "kind": "LinkedField",
                    "name": "taskExecution",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TeamScheduleInlineRoutineOccasion",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "currentEmployee",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfileScreenEmployee_employee"
              },
              (v13/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v24/*: any*/),
              (v27/*: any*/),
              {
                "alias": "assignedTodos",
                "args": (v29/*: any*/),
                "concreteType": "TodoConnection",
                "kind": "LinkedField",
                "name": "todos",
                "plural": false,
                "selections": (v31/*: any*/),
                "storageKey": null
              },
              {
                "alias": "createdTodos",
                "args": (v32/*: any*/),
                "concreteType": "TodoConnection",
                "kind": "LinkedField",
                "name": "todos",
                "plural": false,
                "selections": (v31/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "todoCategories(includeDefault:true)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "StoreViewer",
        "kind": "LinkedField",
        "name": "storeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "events",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isTeamScheduleEventOccasion"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v50/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Routine",
                    "kind": "LinkedField",
                    "name": "routine",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v16/*: any*/),
                      (v58/*: any*/),
                      (v10/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v64/*: any*/)
                ],
                "type": "RoutineOccasion",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskExecutionCheck",
                    "kind": "LinkedField",
                    "name": "taskExecution",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Store",
                            "kind": "LinkedField",
                            "name": "store",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v55/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notDoneStatus",
                            "storageKey": null
                          },
                          (v56/*: any*/),
                          (v57/*: any*/),
                          (v36/*: any*/),
                          (v38/*: any*/),
                          (v5/*: any*/),
                          (v50/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Routine",
                            "kind": "LinkedField",
                            "name": "routine",
                            "plural": false,
                            "selections": [
                              (v63/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "descriptionImages",
                                "plural": true,
                                "selections": (v65/*: any*/),
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v64/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaskCheck",
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sectionId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routine",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v16/*: any*/),
                          (v58/*: any*/),
                          (v10/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v62/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "checkValue",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TeamScheduleInlineRoutineOccasion",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreZonedDate",
                    "kind": "LinkedField",
                    "name": "endAtDate",
                    "plural": false,
                    "selections": (v33/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "TeamScheduleOneOffEvent",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "currentEmployee",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v47/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployeeRole",
                "kind": "LinkedField",
                "name": "assignedRoles",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployeeShift",
                "kind": "LinkedField",
                "name": "shifts",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v66/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formattedStartAtTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formattedEndAtTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeScheduleSecondaryType",
                    "kind": "LinkedField",
                    "name": "secondaryScheduleType",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v16/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeScheduleType",
                    "kind": "LinkedField",
                    "name": "scheduleType",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeams",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v7/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v24/*: any*/),
              (v27/*: any*/),
              {
                "alias": "assignedTodos",
                "args": (v29/*: any*/),
                "concreteType": "TodoConnection",
                "kind": "LinkedField",
                "name": "todos",
                "plural": false,
                "selections": (v78/*: any*/),
                "storageKey": null
              },
              {
                "alias": "createdTodos",
                "args": (v32/*: any*/),
                "concreteType": "TodoConnection",
                "kind": "LinkedField",
                "name": "todos",
                "plural": false,
                "selections": (v78/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "todoCategories(includeDefault:true)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d82cf3384f029746ef2f07fcbbf129d7",
    "id": null,
    "metadata": {},
    "name": "ProfileScreenQuery",
    "operationKind": "query",
    "text": "query ProfileScreenQuery(\n  $currentEmployeeId: ID\n) {\n  me {\n    stores {\n      id\n    }\n    id\n  }\n  storeViewer(employeeId: $currentEmployeeId) {\n    events {\n      id\n      startAt\n      __typename\n      ...TeamScheduleListItem_TeamScheduleEventOccasion\n      ... on RoutineOccasion {\n        routine {\n          ownerTeam {\n            color\n            id\n          }\n          currentSchedule {\n            __typename\n          }\n          description\n          descriptionImages {\n            __typename\n            id\n          }\n          id\n        }\n        assigned {\n          id\n        }\n        assignedRoles {\n          id\n        }\n      }\n      ... on TeamScheduleInlineRoutineOccasion {\n        taskExecution {\n          routineOccasion {\n            routine {\n              ownerTeam {\n                color\n                id\n              }\n              currentSchedule {\n                __typename\n              }\n              description\n              descriptionImages {\n                __typename\n                id\n              }\n              id\n            }\n            assigned {\n              id\n            }\n            assignedRoles {\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n  store {\n    id\n    currentEmployee(id: $currentEmployeeId) {\n      ...ProfileScreenEmployee_employee\n      name\n      id\n    }\n    myRole\n    todoCategories(includeDefault: true) {\n      id\n      title\n      icon\n      assignedCount: todos(assignedToEmployeeId: $currentEmployeeId, assignedToMe: true, includeNewlyCompleted: false, includeSubTodos: true, status: PENDING) {\n        totalCount\n      }\n      createdCount: todos(createdByMe: true, createdByEmployeeId: $currentEmployeeId, includeNewlyCompleted: false, includeSubTodos: true, status: PENDING) {\n        totalCount\n      }\n      assignedTodos: todos(assignedToEmployeeId: $currentEmployeeId, assignedToMe: true, includeNewlyCompleted: true, includeSubTodos: true, status: PENDING) {\n        edges {\n          node {\n            id\n            ordinal\n            ...TodoListItem_todo\n          }\n        }\n      }\n      createdTodos: todos(createdByMe: true, createdByEmployeeId: $currentEmployeeId, includeNewlyCompleted: true, includeSubTodos: true, status: PENDING) {\n        edges {\n          node {\n            id\n            ordinal\n            ...TodoListItem_todo\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AHImageStackComponent_Images on Image {\n  id\n  ...Image_image\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment CreatedBySubject_actor on Actor {\n  __isActor: __typename\n  ...SignedActorCompact_actor\n}\n\nfragment DescriptionContentFiles_files on File {\n  id\n  url\n  ...FileCollectionItem_File\n}\n\nfragment DescriptionContentMedia_Media on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  __typename\n}\n\nfragment FileCollectionItem_File on File {\n  name\n  id\n  url\n  type\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment ProfileScreenEmployeeEmployeeName_employee on Employee {\n  name\n  assignedRoles {\n    id\n    name\n  }\n}\n\nfragment ProfileScreenEmployeeProfileImage_employee on Employee {\n  id\n  image {\n    __typename\n    ... on Image {\n      id\n      ...Image_image\n      __typename\n    }\n  }\n}\n\nfragment ProfileScreenEmployeeTodaysShifts_employee on Employee {\n  id\n  shifts {\n    id\n    ...ProfileScreenEmployeeTodaysShifts_employeeShift\n  }\n}\n\nfragment ProfileScreenEmployeeTodaysShifts_employeeShift on EmployeeShift {\n  id\n  status\n  formattedStartAtTime\n  formattedEndAtTime\n  secondaryScheduleType {\n    color\n    title\n    id\n  }\n  scheduleType {\n    color\n    title\n    assignedTeams {\n      id\n      color\n      ...AHTeamIcon\n    }\n    id\n  }\n}\n\nfragment ProfileScreenEmployee_employee on Employee {\n  name\n  ...ProfileScreenEmployeeProfileImage_employee\n  ...ProfileScreenEmployeeEmployeeName_employee\n  ...ProfileScreenEmployeeTodaysShifts_employee\n}\n\nfragment RoutineOccasionDescriptionContent_Routine on Routine {\n  descriptionImages {\n    ...DescriptionContentMedia_Media\n    id\n  }\n  description\n  descriptionFiles {\n    ...DescriptionContentFiles_files\n    id\n  }\n}\n\nfragment RoutineOccasionListItemAssignedEmployees_RoutineOccasion on RoutineOccasion {\n  assigned {\n    id\n    employee {\n      id\n      isLinkedToViewer\n      ...ListItemAssignees_employees\n    }\n    assignedAt\n  }\n  assignedRoles {\n    role {\n      ...ListItemAssignees_roles\n      id\n    }\n    id\n  }\n}\n\nfragment RoutineOccasionScreenRoutineDescription_Routine on Routine {\n  title\n  isOrg\n  ...RoutineOccasionDescriptionContent_Routine\n}\n\nfragment RoutineOccasionStatusCircleInline_RoutineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  deadlineAt\n  startAt\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment SignedActorCompactBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n  }\n  ... on ConnectActor {\n    __typename\n  }\n}\n\nfragment SignedActorCompact_actor on Actor {\n  __isActor: __typename\n  ...SignedActorText_actor\n  ...SignedActorCompactBadge_actor\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion on TeamScheduleInlineRoutineOccasion {\n  id\n  startAt\n  taskExecution {\n    id\n    task {\n      id\n    }\n    sectionId\n    routineOccasion {\n      id\n      store {\n        myRole\n        id\n      }\n      sequenceNumber\n      notDoneStatus\n      completedTaskExecutionCount\n      totalTaskExecutionCount\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...RoutineOccasionStatusCircleInline_RoutineOccasion\n      ...TeamScheduleRoutineListItemContent_RoutineOccasion\n      ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion\n      ...TeamScheduleListItemScheduleRange_routineOccasion\n    }\n    routine {\n      ...TeamScheduleRoutineListItemContent_Routine\n      id\n    }\n    checkValue\n  }\n}\n\nfragment TeamScheduleListItemMonthlyRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  startAt\n  deadlineAt\n}\n\nfragment TeamScheduleListItemScheduleRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  ...TeamScheduleListItemWeeklyRange_routineOccasion\n  ...TeamScheduleListItemMonthlyRange_routineOccasion\n}\n\nfragment TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  __typename\n  ... on RoutineOccasion {\n    startAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n    deadlineAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routineOccasion {\n        startAtDate {\n          ...StoreFormattedDate_1b2lNL\n        }\n        deadlineAtDate {\n          ...StoreFormattedDate_1b2lNL\n        }\n        id\n      }\n      id\n    }\n  }\n  ... on TeamScheduleOneOffEvent {\n    startAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n    endAtDate {\n      ...StoreFormattedDate_1b2lNL\n    }\n  }\n}\n\nfragment TeamScheduleListItemWeeklyRange_routineOccasion on ScheduledOccasion {\n  __isScheduledOccasion: __typename\n  startAt\n  deadlineAt\n}\n\nfragment TeamScheduleListItem_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  __typename\n  ...TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion\n  ... on RoutineOccasion {\n    ...TeamScheduleRoutineOccasionListItem_RoutineOccasion\n    routine {\n      id\n      isArchived\n      ...RoutineOccasionScreenRoutineDescription_Routine\n    }\n  }\n  ... on TeamScheduleInlineRoutineOccasion {\n    ...TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  title\n  isOrg\n  description\n  orgIconUri\n  isArchived\n  ...RoutineOccasionScreenRoutineDescription_Routine\n  descriptionImages {\n    ...AHImageStackComponent_Images\n    id\n  }\n}\n\nfragment TeamScheduleRoutineListItemContent_RoutineOccasion on RoutineOccasion {\n  assigned {\n    employee {\n      id\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n    }\n    id\n  }\n  ...RoutineOccasionListItemAssignedEmployees_RoutineOccasion\n}\n\nfragment TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion on RoutineOccasion {\n  issueCount\n}\n\nfragment TeamScheduleRoutineOccasionListItem_RoutineOccasion on RoutineOccasion {\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  ...TeamScheduleRoutineListItemContent_RoutineOccasion\n  ...TeamScheduleRoutineOccasionListItemBadgeNew_routineOccasion\n  ...TeamScheduleListItemScheduleRange_routineOccasion\n  sequenceNumber\n  completedTaskExecutionCount\n  totalTaskExecutionCount\n  routine {\n    id\n    ...TeamScheduleRoutineListItemContent_Routine\n  }\n}\n\nfragment TodoCircleStatusWithResponse_todo on Todo {\n  id\n  expireAt\n  status\n  canChangeStatus\n  canWrite\n  ordinal\n  isResponseCompleted\n  response {\n    __typename\n    ... on TodoResponseNumber {\n      __typename\n    }\n    ... on TodoResponseImage {\n      __typename\n      images {\n        id\n        ...Image_image\n      }\n    }\n    ... on TodoResponseText {\n      __typename\n    }\n  }\n}\n\nfragment TodoListItemAssignedUsers_todo on Todo {\n  assigned {\n    assignedAt\n    employee {\n      id\n      ...ListItemAssignees_employees\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n      ...ListItemAssignees_roles\n    }\n    id\n  }\n}\n\nfragment TodoListItemCompletedInfo_todo on Todo {\n  resolvedAtDate {\n    ...StoreFormattedDate\n  }\n  lastChangedStatusByActor {\n    __typename\n    ...Avatar_actor\n  }\n}\n\nfragment TodoListItemContact_todo on Todo {\n  contact {\n    name\n    phoneNumber\n    email\n  }\n  feedbackStatus\n}\n\nfragment TodoListItemFooterDone_todo on Todo {\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n}\n\nfragment TodoListItemFooterPending_todo on Todo {\n  ...TodoListItemAssignedUsers_todo\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n  expireAtDate {\n    ...StoreFormattedDate\n    isoString\n  }\n  tags {\n    ...TodoListItemTags_tag\n  }\n  assigned {\n    __typename\n    id\n  }\n  assignedRoles {\n    __typename\n    id\n  }\n  linkedProducts {\n    ...TodoListItemProducts_StoreProduct\n    id\n  }\n  ...TodoListItemFooterSubTodos_todo\n  subTodos {\n    __typename\n    id\n  }\n  commentCount\n}\n\nfragment TodoListItemFooterSubTodos_todo on Todo {\n  id\n  subTodos {\n    status\n    id\n  }\n}\n\nfragment TodoListItemFooter_todo on Todo {\n  ...TodoListItemFooterDone_todo\n  ...TodoListItemFooterPending_todo\n  status\n}\n\nfragment TodoListItemHeaderWrapper_todo on Todo {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  timeToResolvedFormatted\n}\n\nfragment TodoListItemHeader_todo on Todo {\n  ...TodoListItemHeaderWrapper_todo\n  subject {\n    ...TodoSubject_TodoSubject\n  }\n  title\n  isIssue\n  createdByActor {\n    __typename\n    ...CreatedBySubject_actor\n  }\n}\n\nfragment TodoListItemMainContentDetails_todo on Todo {\n  ...TodoListItemCompletedInfo_todo\n  status\n  images {\n    id\n    ...Image_image\n  }\n  linkedProducts {\n    imageUrl\n    id\n  }\n}\n\nfragment TodoListItemMainContentText_todo on Todo {\n  title\n  isIssue\n  status\n}\n\nfragment TodoListItemPriority_todo on Todo {\n  priority\n  status\n}\n\nfragment TodoListItemProducts_StoreProduct on StoreProduct {\n  name\n}\n\nfragment TodoListItemTags_tag on TodoCategoryTag {\n  id\n  color\n  title\n}\n\nfragment TodoListItem_todo on Todo {\n  id\n  status\n  ordinal\n  response {\n    __typename\n  }\n  canWrite\n  isOrg\n  body\n  formattedBody\n  canChangeStatus\n  ...TodoListItemMainContentText_todo\n  ...TodoListItemPriority_todo\n  ...TodoListItemFooter_todo\n  ...TodoCircleStatusWithResponse_todo\n  ...TodoListItemMainContentDetails_todo\n  ...TodoListItemHeader_todo\n}\n\nfragment TodoSubjectIcon_TodoSubject on TodoSubject {\n  icon\n  iconUri\n}\n\nfragment TodoSubject_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    requiredToDescribeTodo\n  }\n  ...TodoSubjectIcon_TodoSubject\n}\n"
  }
};
})();

(node as any).hash = "b4228c62efa3adb6d7250eb6d19927ab";

export default node;
